<template>
  <div class="menu-profile-box m-r-xs-15">
    <div class="menu-profile">
      <template v-if="user">
        <router-link
          :to="{ name: 'MyProfile' }"
          class="custom-profile m-r-xs-15"
        >
          <vue-load-image v-if="user && user.file">
            <img
              slot="image"
              class="profile m-r-xs-10"
              :src="user.file.url_view | resizeImage(43, 43)"
              :data-src="user.file.url_view | resizeImage(43, 43)"
            >
            <div
              slot="preloader"
              v-loading="true"
              class="img-loading"
            >
              {{ $t('Loading ....') }}
            </div>
            <div slot="error">
              {{ $t('Network error') }}
            </div>
          </vue-load-image>
          <img
            v-else
            class="profile m-r-xs-10"
            src="../assets/profile-default.png"
          >
          <span class="name">{{ user.name }}</span>
        </router-link>
        <router-link :to="{ name: 'Messages' }">
          <el-button
            class="mail"
            icon="icon-massage"
          />
        </router-link>
      </template>
      <template v-else>
        <router-link
          :to="{ name: 'About' }"
          class="about-us"
        >
          {{ $t('header.button.details') }}
        </router-link>
        <router-link
          :to="{ name: 'Welcome' }"
          tag="el-button"
          class="nav-new-ad btn-icon-user"
        >
          {{ $t('header.button.login') }}
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MenuItem',
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MenuItem.vue